<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[{ type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true}]"
    />

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>점검종류</div>
          <p v-if="isPrint" class="print-input">{{ form.점검종류 }}</p>
          <div v-else class="h-full flex items-center">
            <radio-group v-model="form.점검종류" flex :items="['정기', '수시']"/>
          </div>
        </div>
        <div class="writeGridCol2" style="align-self: start">
          <div>점검일</div>
          <p v-if="isPrint" class="print-input">{{ form.점검일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.점검일" />
        </div>
        <div class="writeGridCol2" >
          <div style="align-self: start; padding-top: 8px;">점검기관</div>
          <p v-if="isPrint" class="print-input">{{ form.점검기관.join(', ') }}</p>
          <div v-else>
            <div class="flex">
              <vs-input class="w-full mr-2" v-model="form.점검기관[0]" :readonly="board.readonly"/>
              <button style="background: none; border: 1px solid #7e72f2; border-radius: 4px; width: 38px;" class="cursor-pointer" @click="addItem">
                <vs-icon icon-pack="feather" icon="icon-plus" style="color: #7e72f2" />
              </button>
            </div>

            <div v-for="(item, itemIndex) of form.점검기관">
              <div v-if="itemIndex !== 0" class="mt-2 flex">
                <vs-input class="w-full mr-2" v-model="form.점검기관[itemIndex]" :readonly="board.readonly"/>
                <button style="background: none; border: 1px solid #7e72f2; border-radius: 4px; width: 38px;" class="cursor-pointer" @click="delItem(itemIndex)">
                  <vs-icon icon-pack="feather" icon="icon-minus" style="color: #7e72f2" />
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <div class="flex">
        <h5 class="title"><i class="dot"></i>점검대상</h5>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        <div v-for="target in form.점검대상">
          <vs-checkbox v-model="target.check">{{ target.name }}</vs-checkbox>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>시료채취 유무</div>
          <p v-if="isPrint" class="print-input">{{ form.시료채취유무 }}</p>
          <div v-else class="w-full flex-1 flex gap-4">
            <vs-radio v-model="form.시료채취유무" :disabled="board.readonly" vs-name="check" vs-value="유">O</vs-radio>
            <vs-radio v-model="form.시료채취유무" :disabled="board.readonly" vs-name="check" vs-value="무">X</vs-radio>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>점검내용</div>
          <p v-if="isPrint" class="print-input">{{ form.점검내용 }}</p>
          <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.점검내용" :max="1000" :readonly="board.readonly"/>
        </div>
        <div class="writeGridLineItem">
          <div>시료채취사항</div>
          <p v-if="isPrint" class="print-input">{{ form.시료채취사항 }}</p>
          <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.시료채취사항" :max="1000" :readonly="board.readonly"/>
        </div>
        <div class="writeGridLineItem">
          <div>점검자</div>
          <p v-if="isPrint" class="print-input">{{ form.점검자 }}</p>
          <div v-else class="grid">
            <ml-input  class="w-1/3" v-model="form.점검자" :max="100"/>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <div class="flex">
        <h5 class="title"><i class="dot"></i>점검결과</h5>
      </div>
      <div class="grid grid-cols-1 xl:grid-cols-2 mt-6 gap-y-4">
        <div v-for="target in form.점검결과">
          <vs-checkbox v-model="target.check" @change="onChangeResult(target.type)">{{ target.type }}</vs-checkbox>

          <div v-show="target.check && target.type !== '없음'">
            <div class="flex ml-2 mt-2 ">
              <span class="m-2" style="min-width: 60px; align-self: start;">세부사항</span>
              <ml-textarea class="w-full mb-0" rows="2" v-model="target.세부사항" :max="100" :readonly="board.readonly"/>

<!--              <span class="m-2" style="min-width: 60px;" :style="data.name === '대책사항' || data.name === '권고사항' ? 'align-self:start' : 'align-self: center'">{{ data.name }}</span>-->
<!--              <ml-textarea v-if="data.name === '대책사항' || data.name === '권고사항' " class=" w-full" rows="2" v-model="data.value" :max="100" :readonly="board.readonly"/>-->
<!--              <ml-input v-else class="w-full" v-model="data.value" :max="40"/>-->
            </div>
          </div>
        </div>
      </div>
      <div v-if="isShow점검결과">
        <div v-for="item in 점검결과사항Array" :key="item.name" class="flex mt-2">
          <span style="width: 90px;" :style="item.name === '대책사항'? {'align-self': 'top', 'padding-top' : '6px'} : {'align-self': 'center'}">{{ item.name }}</span>
          <ml-textarea v-if="item.name === '대책사항'" v-model="form.점검결과사항[item.name]" class="w-full"/>
          <ml-input v-else v-model="form.점검결과사항[item.name]" class="w-full"/>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" title="첨부문서" class="w-full mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import Print from "./Print.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  components: {
    RadioGroup,
    Print,
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
        체크점검대상: [],
        체크지적사항: '',

        점검종류: '',
        점검일: '',
        점검기관: [''],
        점검대상: [
          { check: false, name: '대기(일반)' },
          { check: false, name: '대기(총량)' },
          { check: false, name: '비산먼지' },
          { check: false, name: '비산배출(Haps)' },
          { check: false, name: '수질' },
          { check: false, name: '하수' },
          { check: false, name: '폐기물' },
          { check: false, name: '토양' },
          { check: false, name: '악취' },
          { check: false, name: '소음진동' },
          { check: false, name: '화학물질' },
          { check: false, name: '잔류성유기오염물질' },
        ],
        시료채취유무: '',
        점검내용: '',
        시료채취사항: '',
        점검자: '',
        점검결과: [
          {
            check: false, type: '행정처분', 세부사항: ""
          },
          {
            check: false, type: '벌금', 세부사항: ""
          },
          {
            check: false, type: '과태료', 세부사항: ""
          },
          {
            check: false, type: '권고', 세부사항: ""
          },
          {
            check: false, type: '없음',
          },
        ],
        점검결과사항: {
          위반사항: '',
          근거법령: '',
          처분사항: '',
          대책사항: '',
        },
      }
    };
  },
  computed: {
    점검결과Map() {
      return this.form.점검결과.reduce((map, item) => {
        map[item.type] = item;
        return map;
      }, {});
    },
    isShow점검결과() {
      if (this.점검결과Map['행정처분'].check || this.점검결과Map['벌금'].check || this.점검결과Map['과태료'].check || this.점검결과Map['권고'].check) {
        return true;
      } else {
        return false;
      }
    },
    점검결과사항Array() {
      return Object.keys(this.form.점검결과사항).map(key => {
        return { name: key, value: this.form.점검결과사항[key] };
      });
    }
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.점검대상' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.체크점검대상 = value.filter(item => item.check).map(item => item.name)
      }
    },
    'form.점검결과' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.체크지적사항 = value.filter(item => item.check).map(item => item.type).join(', ');
      }
    },
  },
  methods: {
    addItem() {
      this.form.점검기관.push('');
    },
    delItem(index) {
      this.form.점검기관.splice(index, 1);
    },
    onChangeResult(type) {
      if (type === '없음') {
        // 없음 선택시 다른것들은 false
        if (this.점검결과Map['없음'].check) {
          this.form.점검결과.forEach(item => {
            if (item.type !== '없음') {
              item.check = false;
            }
          })
        }
      } else {
        // 다른것 선택시 없음은 false
        this.점검결과Map['없음'].check = false;
      }

    }
  }
};
</script>
<style lang="scss" scoped>
</style>
